<script setup>
import PageHeader from 'dashboard/components-next/layout/PageHeader.vue';
</script>

<template>
  <PageHeader
    icon="i-lucide-timer"
    accent="ruby"
    :title="$t('SLA.HEADER')"
    :subtitle="$t('SLA.DESCRIPTION')"
  />
</template>
